import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Download, Eye } from 'lucide-react';

export default function PreviewPage() {
  const navigate = useNavigate();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [fileName, setFileName] = useState('contract.docx');

  useEffect(() => {
    // 从 location state 获取预览数据
    const state = window.history.state?.usr;
    if (state?.blob) {
      const url = URL.createObjectURL(state.blob);
      setPreviewUrl(url);
      setFileName(state.fileName || 'contract.docx');
    }
  }, []);

  const handleDownload = () => {
    if (!previewUrl) return;
    const a = document.createElement('a');
    a.href = previewUrl;
    a.download = fileName;
    a.click();
  };

  return (
    <div className="space-y-6">
      {/* 页面标题 */}
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-500"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <h1 className="text-xl font-bold text-gray-800">合同预览</h1>
      </div>

      {/* 操作栏 */}
      <div className="bg-white rounded-xl p-4 border border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Eye className="w-5 h-5 text-primary" />
          <span className="font-medium text-gray-800">{fileName}</span>
        </div>
        <button
          onClick={handleDownload}
          className="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary-dark transition-colors"
        >
          <Download className="w-4 h-4" />
          下载合同
        </button>
      </div>

      {/* 预览区域 */}
      <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <div className="bg-gray-50 px-4 py-2 border-b border-gray-200 flex items-center justify-between">
          <span className="text-sm font-medium text-gray-700">文档预览</span>
          <span className="text-xs text-gray-400">建议在 Microsoft Word 或 WPS 中打开以获得最佳体验</span>
        </div>
        <div className="p-8 min-h-[600px] bg-gray-50 flex items-center justify-center">
          {previewUrl ? (
            <div className="w-full max-w-4xl bg-white shadow-lg rounded-lg overflow-hidden">
              <div className="bg-gray-100 px-4 py-2 text-xs text-gray-500 border-b">
                {fileName}
              </div>
              <div className="p-12 text-center text-gray-500">
                <p className="mb-2">由于浏览器安全限制，无法直接预览 Word 文档内容</p>
                <p className="text-sm">请点击"下载合同"按钮，使用 Word 或 WPS 打开查看</p>
              </div>
            </div>
          ) : (
            <div className="text-center">
              <p className="text-gray-500 mb-4">暂无预览内容</p>
              <button
                onClick={() => navigate('/generate')}
                className="text-primary hover:underline text-sm"
              >
                返回重新生成
              </button>
            </div>
          )}
        </div>
      </div>

      {/* 提示信息 */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 className="text-sm font-bold text-blue-800 mb-2">使用提示</h3>
        <ul className="text-sm text-blue-700 space-y-1 list-disc list-inside">
          <li>生成的合同已 100% 保留原模板的所有格式</li>
          <li>所有变量已自动替换为实际信息</li>
          <li>请在 Word/WPS 中打开下载的文件进行最终核对</li>
          <li>如需修改，请在 Word 中直接编辑后保存</li>
        </ul>
      </div>
    </div>
  );
}
